import { CookieService } from '@/services/cookie';
import { LOGIN_ACTIONS_CONSTANTS } from '@/domain/login';
import { ROUTER_PATHS } from '@/router/paths';
import { AuthClient } from '@/services/models/authentication';
import { sessionServiceDomain } from '@/domain/session';
import { updateAuthToken } from '@/services/axios-client';
import { mParticleMetric } from '@/metrics';
import { CheckoutSession } from '@/services/checkout';

export default (redirectAction = LOGIN_ACTIONS_CONSTANTS.CHECKOUT) => ({
    data() {
        return {
            userId: '',
            code: null,
            client: null,
        };
    },

    async mounted() {
        const checkoutSession = CheckoutSession.get();
        this.userId = this.getUserId();
        this.code = this.$route.query.code;
        this.client = this.$route?.query?.client ?? checkoutSession?.client;

        if (this.hasNoValidSession()) {
            this.redirectToLogin();
            return;
        }

        if (this.hasUserIdWithoutRefreshToken()) {
            await this.getRefreshTokenByCode();
        }
    },

    methods: {
        hasNoValidSession() {
            return !CookieService.getCookie('refresh_token') && !this.userId;
        },

        hasUserIdWithoutRefreshToken() {
            return !CookieService.getCookie('refresh_token') && this.userId;
        },

        redirectToLogin() {
            this.$router.push({
                path: ROUTER_PATHS.HOME,
                query: {
                    action: redirectAction,
                    extraData: {
                        client: this.client,
                    },
                },
            });
        },

        getUserId() {
            const userIdCookie = CookieService.getCookie('userId');
            const userIdQueryParam = this.$route.query.userId;

            if (userIdCookie) {
                return userIdCookie;
            }

            if (userIdQueryParam) {
                return userIdQueryParam;
            }

            return null;
        },

        async getRefreshTokenByCode() {
            if (!this.code) {
                return;
            }

            try {
                const { data } = await AuthClient.getAccessToken(this.code);
                if (data.access_token && data.refresh_token) {
                    sessionServiceDomain.setLoginCookies(data);
                    updateAuthToken(data.access_token);
                }
            } catch (error) {
                sessionServiceDomain.deleteLoginCookies();
                mParticleMetric.track(mParticleMetric.EVENTS.ACCOUNTS_WEB_UNEXPECTED_ERROR_OCCURRED, {
                    login_error_reason: 'checkout_failed_access_token',
                });
                this.$router.push({
                    path: ROUTER_PATHS.ACCOUNT_ACTIVATED_ERROR,
                    query: {
                        action: redirectAction,
                    },
                });
            }
        },
    },
});

